export default "__VITE_ASSET__890a433c__"